import { useState, useEffect } from "react";
import { Spinner } from "react-bootstrap";
import TextTransition, { presets } from "react-text-transition";
import {
  AnalyzeCategory,
  criptoCategories,
  forexCategories,
  genericCategories,
  stockCategories,
} from "./data/analyze-categories";
import { eAssetType } from "../../../@types/Asset";

interface Props {
  assetType?: eAssetType;
  show: boolean;
}
export default function LoadingAnalysis({ assetType, show }: Props) {
  const [index, setIndex] = useState<number>(0);
  const [spinnerColor, setSpinnerColor] = useState<string>("");
  const categories = getCategories(assetType);

  useEffect(() => {
    setIndex(0);
  }, [assetType]);

  useEffect(() => {
    const intervalId = setInterval(() => {
      setSpinnerColor("#5af271");

      setTimeout(() => {
        setIndex((oldIndex) => oldIndex + 1);
        setSpinnerColor("");
      }, 250);
    }, 1500);
    return () => clearTimeout(intervalId);
  }, []);

  if (!show) {
    return <></>;
  }

  return (
    <div className="card card-minimal-four">
      <div className="card-body">
        <div className="text-center pd-t-30 pd-b-5">
          {categories[index % categories.length].icon}
        </div>
        <div className="d-flex justify-content-center text-center pd-l-20 pd-r-20">
          <h1>
            <TextTransition
              className="tx-light"
              text={categories[index % categories.length].title}
              springConfig={presets.wobbly}
            />
          </h1>
        </div>
        <div className="text-center pd-b-30">
          <Spinner
            style={{ marginTop: 5, color: spinnerColor }}
            animation="border"
            size="sm"
          />
        </div>
      </div>
    </div>
  );
}

function getCategories(assetType?: eAssetType): AnalyzeCategory[] {
  switch (assetType) {
    case eAssetType.STOCK:
      return stockCategories;
    case eAssetType.FOREX:
      return forexCategories;
    case eAssetType.CRIPTO:
      return criptoCategories;
    default:
      return genericCategories;
  }
}
